/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react';
import Tab from './landing/Tab';

function TabManager({
  tabs,
  setTabs,
  handleCloseTab,
  currentTabIndex,
  handleShowTab,
}) {
  useEffect(() => {
    return () => {
      setTabs([]);
    };
  }, []);

  return (
    <div className="tab-manager" style={{}}>
      <ul
        className="nav nav-tabs"
        style={{display: 'flex', overflowX: 'auto', overflowY: 'hidden'}}>
        {tabs.map((tab, index) => (
          <li
            role="presentation"
            className={currentTabIndex === index ? 'active' : ''}
            key={index}
            onClick={() => handleShowTab(index)}>
            <a
              style={{
                cursor: 'pointer',
                display: 'flex',
                color: '#616161',
                paddingRight: 10,
                fontSize: 13,
              }}>
              {tab.title}{' '}
              <button
                className="btn btn-sm"
                onClick={event => {
                  event.stopPropagation();
                  handleCloseTab(index);
                }}
                style={{
                  marginLeft: 5,
                  padding: 0,
                  height: 20,
                  width: 20,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: 'solid 1px #ccc',
                  backgroundColor: 'transparent',
                }}>
                x
              </button>
            </a>
          </li>
        ))}
      </ul>
      <div className="tab-content">
        {tabs.map((tab, index) => (
          <Tab
            key={tab.ts} // si se usa index, al cerrar un tab, los posteriores se re-renderizan y pierden el estado (si tipeó algo el usuario por ej.)
            title={tab.title}
            url={tab.url}
            index={index}
            currentTabIndex={currentTabIndex}
          />
        ))}
      </div>
    </div>
  );
}

export default TabManager;
